import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/unbound-method, no-param-reassign */ import { useRef, useMemo, useCallback, useState, useContext, useEffect } from "react";
import * as React from "react";
import { noop } from "./utils";
import { NavigationListContext } from "./NavigationListContext";
export const NavigationListListContext = /*#__PURE__*/ React.createContext({
    listId: "",
    listOptions: {},
    registerItem: ()=>noop,
    setActiveItemId: noop
});
export default function useNavigationList(listId, options) {
    const ref = useRef(null);
    const { registerList , setActiveCoord  } = useContext(NavigationListContext);
    const [items, setItems] = useState([]);
    useEffect(()=>{
        if (!ref.current) throw new Error("useNavigationList's returned ref must be used on a DOM element");
        return registerList(listId, ref.current, options, items);
    }, [
        listId,
        options,
        registerList,
        items
    ]);
    const context = useMemo(()=>({
            listId,
            listOptions: options,
            setActiveItemId (newListItemId) {
                setActiveCoord(()=>newListItemId == null ? null : {
                        listId,
                        listItemId: newListItemId
                    });
            },
            registerItem (listItemId, element, itemOptions) {
                setItems((oldItems)=>{
                    const itemIndex = oldItems.findIndex((item)=>item.listItemId === listItemId);
                    if (itemIndex < 0) {
                        const newItem = {
                            listItemId,
                            element,
                            options: itemOptions
                        };
                        return [
                            ...oldItems,
                            newItem
                        ];
                    } else throw new Error(`Item '${listItemId}' already exists in the list '${listId}'`);
                });
                return ()=>{
                    setItems((oldItems)=>{
                        const itemIndex = oldItems.findIndex((item)=>item.listItemId === listItemId);
                        if (itemIndex >= 0) return [
                            ...oldItems.slice(0, itemIndex),
                            ...oldItems.slice(itemIndex + 1), 
                        ];
                        else throw new Error("Cannot remove item; it didn't exist");
                    });
                };
            }
        }), [
        listId,
        options,
        setActiveCoord
    ]);
    const helpers = useMemo(()=>({
        }), []);
    const Provider = useCallback(({ children  })=>/*#__PURE__*/ _jsx(NavigationListListContext.Provider, {
            value: context,
            children: children
        }), [
        context
    ]);
    return {
        navProps: {
            ref
        },
        helpers,
        Provider
    };
};
